import React from 'react';
import { Dialog, DialogContent, DialogContentText, CircularProgress, Box } from '@mui/material';

interface LoadingDialogProps {
    open: boolean;
    message?: string;
}

const LoadingDialog: React.FC<LoadingDialogProps> = ({ 
    open, 
    message = '処理中です...' 
}) => {
    return (
        <Dialog
            open={open}
            disableEscapeKeyDown
            BackdropProps={{
                sx: {
                    backgroundColor: 'rgba(255,255,255,0.4)', // 背景を少し白く
                    backdropFilter: 'blur(4px)',              // 背景ぼかし
                },
            }}
            PaperProps={{
                sx: {
                    backgroundColor: 'transparent', // 枠なし
                    boxShadow: 'none',
                },
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                p={3}
            >
                <CircularProgress
                    size={60}
                    thickness={6}
                    sx={{
                        animationDuration: '1s',
                        '& .MuiCircularProgress-circle': {
                            animation: 'none',
                        },
                    }}
                />
                <DialogContentText
                    sx={{
                        mt: 2,
                        color: 'text.primary',
                        textAlign: 'center',
                    }}
                >
                    {message}
                </DialogContentText>
            </Box>
        </Dialog>
    );
};

export default LoadingDialog;